import React from 'react';
import { Modal, Form } from 'react-bootstrap';
import { FaCheck } from 'react-icons/fa';
import { IoIosCloseCircle } from 'react-icons/io';

const ScheduleForm2 = ({
  equipmentList,
  truncateText,
  handleAddMachineStatusClick,
  selectedItems,
  handleItemClick,
  handleCloseModal
}) => {
  return (
    <>
      {/* Header */}

      <Modal.Header className="flex-column align-items-center text-center mb-2">
        <Modal.Title>Apply schedule to equipment</Modal.Title>
        <p className="text-muted small mb-0 mt-1">
          Add equipment that should follow your newly created schedule settings.
        </p>
        <div className="cross-close" onClick={handleCloseModal}>
          <IoIosCloseCircle />
        </div>
      </Modal.Header>

      {/* Body */}
      <Modal.Body>
        <Form.Label className="sm-1">Equipment</Form.Label>
        <div className="equipment-list-wrapper">
          {equipmentList?.map((item) => {
            const isSelected = selectedItems?.includes(item?.id);

            return (
              <div
                key={item?.id}
                className={`equipment-item d-flex justify-content-between py-2 px-1 me-2 border-bottom`}>
                <div className="equipment-info  ms-2">
                  <div className="text-muted small ">{truncateText(item?.equipment_name, 50)}</div>

                  {/* Error or overlap messages inline under name */}
                  {!item?.is_machine_status_level_set && (
                    <small className="text-danger">
                      No limits found in machine status.{' '}
                      <span
                        className="text-primary"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleAddMachineStatusClick(item)}>
                        Click here to add them.
                      </span>
                    </small>
                  )}

                  {item?.is_schedule_overlapped && (
                    <small className="text-danger">
                      There is a schedule overlap for this equipment (
                      {item?.overlapped_schedule_name}).<br/> Adding it here will remove it from the
                      other schedule.
                    </small>
                  )}
                </div>
                {/* Custom checkbox with icons */}

                <div
                  className={`checkbox-icon ${
                    !item?.is_machine_status_level_set ? 'disabled' : ''
                  } ms-.2`}
                  onClick={() =>
                    item?.is_machine_status_level_set && handleItemClick(!isSelected, item)
                  }
                  style={{
                    cursor: item?.is_machine_status_level_set ? 'pointer' : 'not-allowed',
                    width: 18, 
                    height: 20, 
                    minWidth: 18, 
                    
                    backgroundColor: '#636363',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                  <FaCheck
                    size={14}
                    color={isSelected ? '#56b30b' : '#ffffff'} // green when selected, white when not
                  />
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>
    </>
  );
};

export default ScheduleForm2;
